import type { MemberProgressSummary } from '@/types/crm.types';

export type AtRiskReason =
  | 'inactive_21d'
  | 'inactive_14d'
  | 'no_first_round'
  | 'no_lesson'
  | 'stage_stuck'
  | 'no_coach';

const SEVERITY: Record<AtRiskReason, number> = {
  inactive_21d: 6,
  no_first_round: 5,
  no_lesson: 4,
  stage_stuck: 3,
  inactive_14d: 2,
  no_coach: 1,
};

export function deriveAtRiskReasons(member: MemberProgressSummary): AtRiskReason[] {
  const reasons: AtRiskReason[] = [];

  const daysSinceActive = member.last_active
    ? Math.floor((Date.now() - new Date(member.last_active).getTime()) / 86_400_000)
    : 999;

  if (daysSinceActive >= 21) reasons.push('inactive_21d');
  else if (daysSinceActive >= 14) reasons.push('inactive_14d');

  if (member.tier === 'onboarding' && member.onboarding_data) {
    const od = member.onboarding_data;
    if (od.days_since_last_advance >= 14) reasons.push('stage_stuck');
    if (!od.assigned_coach) reasons.push('no_coach');
  }

  return reasons
    .sort((a, b) => SEVERITY[b] - SEVERITY[a])
    .slice(0, 2);
}

export function atRiskReasonLabel(reason: AtRiskReason): string {
  switch (reason) {
    case 'inactive_21d': return '21d inactive';
    case 'inactive_14d': return '14d inactive';
    case 'no_first_round': return 'no round yet';
    case 'no_lesson': return 'no lesson yet';
    case 'stage_stuck': return 'stuck at stage';
    case 'no_coach': return 'no coach';
  }
}
